import {booleanAttribute, Component, computed, input, output} from '@angular/core';
import {MatButton} from '@angular/material/button';

/**
 * Bar at the bottom of forms with Annuleren and the primary button, sticky within the content column.
 * Place it as the last child of `app-page`. The primary button explains why it is disabled:
 * "Er zijn geen wijzigingen" / "Vul de verplichte velden in". Projected content goes on the left
 * (e.g. a delete button).
 */
@Component({
    selector: 'app-sticky-save-bar',
    imports: [MatButton],
    templateUrl: './sticky-save-bar.component.html',
    styleUrl: './sticky-save-bar.component.scss'
})
export class StickySaveBarComponent {
    readonly dirty = input(false, {transform: booleanAttribute});
    readonly valid = input(true, {transform: booleanAttribute});
    readonly saving = input(false, {transform: booleanAttribute});
    readonly saveLabel = input('Opslaan');
    readonly cancelLabel = input('Annuleren');
    readonly showCancel = input(true, {transform: booleanAttribute});

    readonly save = output<void>();
    readonly cancel = output<void>();

    readonly canSave = computed(() => this.dirty() && this.valid() && !this.saving());
    readonly label = computed(() => {
        if (!this.dirty()) {
            return 'Er zijn geen wijzigingen';
        }
        if (!this.valid()) {
            return 'Vul de verplichte velden in';
        }
        return this.saving() ? `${this.saveLabel()}…` : this.saveLabel();
    });
}
